import { useGlobalState } from '@/hooks';
import type { IPmtOnboardingPopup } from '@/interfaces/tracking';
import { LoginMethod } from '@/interfaces/user.interfaces';
import { PopupComponentMapping } from '@/modules/pmt/components/TrackingOnboardingPopup/components/Popups';
import { TwoPanelCenter } from '@/modules/pmt/components/TrackingOnboardingPopup/components/Popups/TwoPanelCenter';
import { useEmailSyncContext } from '@/modules/pmt/context';
import { PmtSignUpStep } from '@/modules/pmt/interfaces';
import { PmtOnboardingPopupVariant } from '@/modules/pmt/interfaces/tracking/trackingOnboardingPopup.interfaces';
import { useEffect } from 'react';

interface LoginPopupProps {
  pmtOnboardingPopUp: IPmtOnboardingPopup;
  pmtEmailSyncOnboardingPopUp: IPmtOnboardingPopup;
}

const LoginPopup = (props: LoginPopupProps) => {
  const { pmtSignUpStep, userInfo, showPMTPopUp, setCurrentPMTSignUpStep, setShowPMTPopUp } = useGlobalState();
  const { isEmailSyncAllowed } = useEmailSyncContext();
  const { pmtOnboardingPopUp, pmtEmailSyncOnboardingPopUp } = props;

  const popUp = isEmailSyncAllowed ? pmtEmailSyncOnboardingPopUp : pmtOnboardingPopUp;

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!showPMTPopUp) return;
    const isGuest = !userInfo?.email;

    if (isGuest) {
      setCurrentPMTSignUpStep(PmtSignUpStep.SignUp);
      return;
    }

    if (userInfo?.authenticationMethod === LoginMethod.Email && !userInfo.verificationStatus) {
      setCurrentPMTSignUpStep(PmtSignUpStep.VerifyEmail);
      return;
    }

    if (userInfo.id) {
      setCurrentPMTSignUpStep(PmtSignUpStep.Success);
    }
  }, [userInfo, showPMTPopUp]);

  if (!popUp) return null;

  const onCloseOnboardingPopUp = () => setShowPMTPopUp(false);

  const renderPopup = () => {
    if (isEmailSyncAllowed && pmtSignUpStep === PmtSignUpStep.SignUp) {
      const PopupComponent = PopupComponentMapping[popUp.variant || PmtOnboardingPopupVariant.TwoPanelCenter];
      return <PopupComponent {...popUp} onCloseOnboardingPopUp={onCloseOnboardingPopUp} />;
    }

    return <TwoPanelCenter {...popUp} onCloseOnboardingPopUp={onCloseOnboardingPopUp} />;
  };

  return renderPopup();
};

export default LoginPopup;
